<template>
  <div v-if="
  this.enableAccessAuthSearch(data.tagd) === true ||
  this.getCurrentPage === '/userdash'
  ">
    <div v-if="btnSpinGetRegisterList === false">
      <v-btn
      :color="ui.btnColor"
      icon v-if="data.size == 'icon'"
      @click="getRegisterList(data.tag, data.tagd, data.tags, data.check)"
      flat dark>
        <v-icon :color="btn.Color"> {{btn.icon}} </v-icon>
      </v-btn>
      <v-btn
      :color="ui.btnColor"
      v-if="data.size == 'flat' || data.size == undefined"
      @click="getRegisterList(data.tag, data.tagd, data.tags, data.check)"
      flat dark>
        <v-icon left :color="btn.Color"> {{btn.icon}} </v-icon>
          {{btn.title}}
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin dark v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin dark v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import registerFunctions from "@/data/functions/mixins/registerFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
export default {
  // eslint-disable-next-line
  mixins: [
    apptheme,
    getList,
    storeFunctions,
    routerFunctions,
    registerFunctions,
    dataSources,
    accessFunctions
  ],
  methods: {
    getRegisterList(tag, tagd, tags, check) {
      this.btnSpinGetRegisterList = true;
      // page title
      let title = this.definePageTitle(tag, tagd, tags);
      this.$store.dispatch("changePageTitle", title);
      // define current original detail
      if (this.getDetailBasic !== null && this.getDetailBasic !== undefined) {
        this.$store.dispatch("changeOrgDetailBasic", this.getDetailBasic);
      }
      // get list
      let store = this.defineStore(tag);
      let router = this.defineRouter(tag);
      // let router = null;
      let sort = "NewestFirst";
      let order = "basic.idg";
      // DEFINE db
      let db = null;
      if (tagd === "A.C1") {
        db = this.dbDocumentArchiveCompany;
      } else if (tagd === "A.F1") {
        db = this.dbDocumentArchiveFacility;
      } else {
        db = this.defineDataSourceFromTag(tagd);
      }

      // console.log("");
      // console.log(">>> GET REGISTER LIST <<< ");
      // console.log("STORE:   " + store);
      // console.log("ROUTER:  " + router);
      // console.log("TAG:  " + tagd);
      // console.log("TAG:  " + tags);
      // console.log(db);
      // Embedded Register
      if (this.getDetailBasic !== null) {
        let reg = this.generateRegisterInfo(this.getDetailBasic);
        this.$store.dispatch("changeRegisterInfo", reg);
      } else {
        this.$store.dispatch("changeRegisterInfo", null);
      }
      this.getListDirectCheck(db, order, sort, store, router, check);
    }
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getDetailBasic", "getUser"]),
    btn() {
      let obj = {
        title: "",
        icon: "",
        color: ""
      };
      if (this.getCurrentPage === "/registerlist") {
        obj.title = "refresh";
        obj.icon = "replay";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "C1" &&
        this.data.tagd === "F1" &&
        this.getCurrentPage === "/companydetail"
      ) {
        obj.title = "facility register";
        obj.icon = "place";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "C1" &&
        this.getCurrentPage !== "/companydetail"
      ) {
        obj.title = "register";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "B6.W" &&
        this.getCurrentPage === "/plandetail"
      ) {
        obj.title = "work register";
        obj.icon = "build";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "M2.M5") {
        obj.title = "maintenance plans";
        obj.icon = "work_history";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "C1" &&
        this.getCurrentPage === "/companymanagement"
      ) {
        obj.title = "facility";
        obj.icon = "place";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "C1" &&
        this.getCurrentPage === "/companymanagement"
      ) {
        obj.title = "facility";
        obj.icon = "place";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "F1" &&
        this.getCurrentPage === "/facilitydash"
      ) {
        obj.title = "register";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "F1" &&
        this.getCurrentPage === "/companydetail"
      ) {
        obj.title = "register";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "A.C1") {
        obj.title = "archived";
        obj.icon = "archive";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "M7") {
        obj.title = "Maint Calls History";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "O1" &&
        this.getCurrentPage === "/facilitydetail"
      ) {
        obj.title = "Notifications";
        obj.icon = "notifications";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "O1" &&
        this.getCurrentPage !== "/facilitydetail"
      ) {
        obj.title = "ops";
        obj.icon = "drag_indicator";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "W1" &&
        this.getCurrentPage === "/facilitydetail"
      ) {
        obj.title = "work list";
        obj.icon = "build";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "A.F1") {
        obj.title = "archived";
        obj.icon = "archive";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "W1" &&
        this.getCurrentPage !== "/facilitydetail"
      ) {
        obj.title = "list";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "W6") {
        obj.title = "register";
        obj.icon = "assignment";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "E6") {
        obj.title = "program";
        obj.icon = "science";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "E8") {
        obj.title = "results";
        obj.icon = "sort";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "E2") {
        obj.title = "MODS";
        obj.icon = "apps";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "E2" &&
        this.getCurrentPage === "/companydash"
      ) {
        obj.title = "eng";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "E1") {
        obj.title = "register";
        obj.icon = "emoji_objects";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "L1") {
        obj.title = "material";
        obj.icon = "category";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "L2" &&
        this.getCurrentPage === "/companydashtechnical"
      ) {
        obj.title = "list";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "M2") {
        obj.title = "strategy";
        obj.icon = "explore";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "M5") {
        obj.title = "list";
        obj.icon = "work_history";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "B1") {
        obj.title = "register";
        obj.icon = "emergency";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "B3" &&
        this.getCurrentPage === "/companydashbusiness"
      ) {
        obj.title = "register";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "B3" &&
        this.getCurrentPage === "/companydetail"
      ) {
        obj.title = "Actions";
        obj.icon = "task";
        obj.color = this.ui.btnColor;
      } else if (
        // eslint-disable-next-line
        this.data.tags === "B3" ||
        this.data.tags === "U1.B3"
      ) {
        obj.title = "actions";
        obj.icon = "task";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "B4" &&
        this.getCurrentPage === "/companydashbusiness"
      ) {
        obj.title = "accounts";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "B4" &&
        this.getCurrentPage === "/companyde"
      ) {
        obj.title = "accounts";
        obj.icon = "reorder";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "B4") {
        obj.title = "budget";
        obj.icon = "savings";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "B6") {
        obj.title = "plan";
        obj.icon = "today";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "B6.W") {
        obj.title = "plan2";
        obj.icon = "today";
        obj.color = this.ui.btnColor;
      } else if (
        this.data.tags === "Q1" ||
        this.data.tags === "B4.Q1" ||
        this.data.tags === "L1.Q1"
      ) {
        obj.title = "orders";
        obj.icon = "shopping_bag";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "S1") {
        obj.title = "register";
        obj.icon = "warning";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "S6") {
        obj.title = "events";
        obj.icon = "report";
        obj.color = this.ui.btnColor;
      } else if (this.data.tags === "A1") {
        obj.title = "Assets";
        obj.icon = "sort";
        obj.color = this.ui.btnColor;
      } else {
        obj.title = "undefined register";
        obj.icon = "info";
        obj.color = this.ui.btnColor;
      }
      return obj;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin
  },
  data() {
    return {
      valid: false,
      btnSpinGetRegisterList: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  }
};
</script>
